// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-group-row {
  display: flex;
}
.logged_user{
  display: flex;
  align-items: left;
}
.form-group {
  flex: 1;
  margin-right: 1rem;
}
.bottom-section {
  display: flex;
  align-items: center;
  margin-top: 2rem;
}
.labels {
  display: flex;
  flex-direction: column;
}

.bottom-section button {
  margin-left: auto;
}
.data-info{
  color: rgb(113, 113, 216);
}
.table-container {
  overflow-x: auto;
  position: relative;
 }
.fixed-column + .fixed-column {
  left: 200px; 
}

.fixed-column {
  position: sticky;
  left: 0;
  /* background: white; */
  z-index: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
}
.mat-header-row .mat-header-cell {
  background-color: blue !important;
  color: blue !important; /* Optional: to make the text readable */
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th, td {
  border: 1px solid white;
  text-align: center;
  padding: 8px;
}

table th {
  background-color: #0b2d71;
  color: white;
  font-weight: bold;
}

td a {
  color: blue;
  text-decoration: none; 
}
`, "",{"version":3,"sources":["webpack://./src/app/modules/permanentdelegation/home/delegation/multipledelegation/multipledelegation.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,sBAAsB,EAAE,wCAAwC;AAClE;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB","sourcesContent":[".form-group-row {\n  display: flex;\n}\n.logged_user{\n  display: flex;\n  align-items: left;\n}\n.form-group {\n  flex: 1;\n  margin-right: 1rem;\n}\n.bottom-section {\n  display: flex;\n  align-items: center;\n  margin-top: 2rem;\n}\n.labels {\n  display: flex;\n  flex-direction: column;\n}\n\n.bottom-section button {\n  margin-left: auto;\n}\n.data-info{\n  color: rgb(113, 113, 216);\n}\n.table-container {\n  overflow-x: auto;\n  position: relative;\n }\n.fixed-column + .fixed-column {\n  left: 200px; \n}\n\n.fixed-column {\n  position: sticky;\n  left: 0;\n  /* background: white; */\n  z-index: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 250px;\n}\n.mat-header-row .mat-header-cell {\n  background-color: blue !important;\n  color: blue !important; /* Optional: to make the text readable */\n}\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\nth, td {\n  border: 1px solid white;\n  text-align: center;\n  padding: 8px;\n}\n\ntable th {\n  background-color: #0b2d71;\n  color: white;\n  font-weight: bold;\n}\n\ntd a {\n  color: blue;\n  text-decoration: none; \n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
